/** Två staplar som jämför resultatet före och efter kursen (samma skala, 0–100 %). */
export function KnowledgeCompare({ pre, post }: { pre: number | null; post: number | null }) {
  const rows = [
    { label: 'I början', value: pre, color: '#8fa3c8' },
    { label: 'I slutet', value: post, color: '#2e8b6e' },
  ];
  return (
    <div className="space-y-2">
      {rows.map((r) => (
        <div key={r.label} className="grid grid-cols-[5rem_1fr_3rem] items-center gap-3 text-sm">
          <span className="text-muted">{r.label}</span>
          <div className="h-3 rounded-full bg-night-100" role="presentation">
            {r.value !== null && (
              <div
                className="h-3 rounded-full"
                style={{ width: `${Math.max(2, r.value)}%`, background: r.color }}
              />
            )}
          </div>
          <span className="text-right font-bold tabular-nums text-night-900">
            {r.value === null ? '–' : `${r.value} %`}
          </span>
        </div>
      ))}
    </div>
  );
}
